import React from 'react';
import ReactChipInput from "react-chip-input";
import Select from 'react-select';
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";

const QuickShotCard = ({
    isEditQuickShots,
    setIsEditQuickShots,
    updateQuickShots,
    quickShots,
    onChangeQuickShotItem,
    ENGAGEMENT_STATUS,
    SUPPORT_TITLE,
    allInputInfo
}) => {
    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Quick shot</h3>
                <div className='card-tools'>
                    {isEditQuickShots &&
                    <button type='button'
                            className='btn btn-default mr-2'
                            onClick={() => {
                                setIsEditQuickShots(false);
                            }}
                    >
                        Cancel
                    </button>
                    }
                    {isEditQuickShots &&
                    <button type='button'
                            className='btn btn-primary'
                            onClick={() => {
                                updateQuickShots();
                            }}
                    >
                        Save
                    </button>
                    }
                    {!isEditQuickShots &&
                    <button type='button'
                            className='btn btn-default'
                            onClick={() => {
                                setIsEditQuickShots(true);
                            }}
                    >
                        Edit
                    </button>
                    }
                </div>
            </div>
            <div className='card-body'>
                <div className='input-group'>
                    <label className={'w-100'}>Lưu ý quan trọng khi tương tác</label>
                    <textarea className='form-control'
                              disabled={!isEditQuickShots}
                              value={quickShots.important_note ? quickShots.important_note : ''}
                              name={'important_note'}
                              onChange={event => onChangeQuickShotItem(event)}/>
                    <AllUserInputField arrInfo={allInputInfo.allCandidateNotesInfo}
                                       field='important_note'/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>General Note</label>
                    <textarea className='form-control'
                              disabled={!isEditQuickShots}
                              value={quickShots.general_note ? quickShots.general_note : ''}
                              name={'general_note'}
                              onChange={event => onChangeQuickShotItem(event)}/>
                    <AllUserInputField arrInfo={allInputInfo.allCandidateNotesInfo}
                                       field='general_note'/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Engagement Status</label>
                    <Select options={ENGAGEMENT_STATUS}
                            className={'w-100'}
                            isMulti
                            name={'engagement_status'}
                            isDisabled={!isEditQuickShots}
                            value={quickShots.engagement_status ? quickShots.engagement_status : ''}
                            onChange={values => onChangeQuickShotItem(values, 'engagement_status')}>
                    </Select>
                    <AllUserInputField arrInfo={allInputInfo.allCandidateNotesInfo}
                                       field='engagement_status'/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Danh hiệu support</label>
                    <Select options={SUPPORT_TITLE}
                            className={'w-100'}
                            isMulti
                            name={'support_title'}
                            isDisabled={!isEditQuickShots}
                            value={quickShots.support_title ? quickShots.support_title : ''}
                            onChange={values => onChangeQuickShotItem(values, 'support_title')}>
                    </Select>
                    <AllUserInputField arrInfo={allInputInfo.allCandidateNotesInfo}
                                       field='support_title'/>
                </div>
            </div>
        </div>
    );
};

export default QuickShotCard;


